module.exports = __webpack_public_path__ + "static/img/percentual.d87ad6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/percentual.png
// module id = ZjRK
// module chunks = 1